<template>
  <div class="equip-auth-page">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">设备编码：</span>
        <el-input class="w-200" v-model="searchData.deviceCode" placeholder="请输入" clearable></el-input>
      </div>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">出货区域：</span>
        <AreaCascader v-model="fullArea" :end-level="2" placeholder="请输入" ></AreaCascader>
      </div>
      <!-- <div class="inline-block">
        <span class="w-60 inline-block align-r m-r-8">项目：</span>
        <el-select v-model="searchData.projectCode" placeholder="请选择" clearable>
          <el-option
            v-for="item in selOptions.projectName"
            :key="item.name"
            :label="item.value"
            :value="item.name"
          ></el-option>
        </el-select>
      </div> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">授权状态：</span>
        <el-select v-model="searchData.authFlag" placeholder="请选择" clearable>
          <el-option label="已授权" :value="1"></el-option>
          <el-option label="未授权" :value="0"></el-option>
        </el-select>
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>
    
    <div class="page-operate-block">
      <el-tabs v-model="curActiveTab" class="el-tabs-card" @tab-click="handleTabClick">
        <el-tab-pane v-for="item in tabsArr" :key="item.name" :label="item.label" :name="item.name">
        </el-tab-pane>
      </el-tabs>

      <div class="inline-block">
        <el-button
          v-permission="'add'"
          class="operate-btn"
          @click="handleEdit('add')"
          >新增</el-button
        >
        <el-button
          v-permission="'edit'"
          class="operate-btn"
          :disabled="options.selection.length != 1"
          @click="handleEdit('edit')"
          >编辑</el-button
        >
        <el-button
          v-permission="'delete'"
          class="operate-btn"
          :disabled="options.selection.length < 1"
          @click="handleDelete"
          >删除</el-button
        >
        <el-button
          v-permission="'import'"
          class="operate-btn"
          @click="handleImport"
          >导入</el-button
        >
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        class="manager-table"
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      ></r-table>
    </div>

    <RModal
      customClass="equip-auth-dialog"
      :title="curModalTitle"
      top="5vh"
      :show="detailModal"
      :closeOnClick="false"
      width="550px"
      @change="detailModal = false"
      @close="closeModel"
    >
      <template #content>
        <ImportView
          v-if="detailType === 'import'"
          ref="modalImportView"
          :show="detailModal"
          :projectList="selOptions.projectName"
          :deviceType="curActiveTab"
          @close="closeModel"
          @success="submitSuccess"
          @show-repeat="showRepeatModal"
        />

        <ImportRepeatView
          v-else-if="detailType === 'repeat'"
          ref="modalRepeatView"
          :resultData="importResultData"
          :totalCount="importTotalCount"
          @close="closeModel"
        />

        <EditView
          v-else
          ref="modalEditView"
          :show="detailModal"
          :editType="detailType"
          :deviceType="curActiveTab"
          :detailData="detailData"
          :projectList="selOptions.projectName"
          @close="closeModel"
          @success="submitSuccess"
        />
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
import AreaCascader from '@/components/common/areaCascader'
import EditView from './editView'
import ImportView from './importView'
import ImportRepeatView from './importRepeatView'

export default {
  name: 'baseInfoManagerMgmt',
  mixins: [tableMix, checkMix],
  components: { RTable, RModal, EditView, AreaCascader, ImportView, ImportRepeatView },
  data() {
    let detailKeys = ['province', 'city', 'area', 'projectCode', 'authFlag', 'deviceCode', 'deviceModel']
    let searchData = {}
    detailKeys.map((key) => {
      searchData[key] = ''
    })
    return {
      importResultData: {},

      authFlagList: ['未授权', '已授权'],

      fullArea: '',
      tabsArr: [
        { label: '门锁', name: '103' },
        { label: '门铃', name: '104' },
      ],
      curActiveTab: '103',

      detailModal: false,
      detailType: 'show',
      downloadUrl: '',
      detailData: {},
      deleteUrl: 'SAAS.GET_DEVICE_AUTH_DEL_BY_IDS',

      tableVarity: 'equip_auth_table',
      tableColumn: [],
      tableData: [],
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: searchData },
      searchData,

      selOptions: { projectName: [], doorbellModel: [] },
      selOptionMaps: { projectName: {}, doorbellModel: {} },
    }
  },
  computed: {
    // 当前弹框标题
    curModalTitle() {
      switch (this.detailType) {
        case 'add':
          if (this.curActiveTab == '103') return '新增门锁'
          return '新增门铃'
        case 'edit':
          if (this.curActiveTab == '103') return '编辑门锁'
          return '编辑门铃'
        case 'import':
          if (this.curActiveTab == '103') return '导入门锁'
          return '导入门铃'
        case 'repeat':
          if (this.curActiveTab == '103') return '导入门锁重复'
          return '导入门铃重复'
      }
      return '？？？'
    },
  },
  watch: {
    detailModal(val) {
      if (val) {
        this.$refs.modalEditView &&
          this.$refs.modalEditView.$refs.integrateAddForm &&
          this.$refs.modalEditView.$refs.integrateAddForm.clearValidate()
      }
    },
    fullArea(val) {
      if (Array.isArray(val)) {
        this.searchData.province = val[0]
        this.searchData.city = val[1]
        this.searchData.area = val[2]
      }
    },
  },
  created() {
    this.initTableColumns()
    this.getDictData(['projectName', 'doorbellModel'])
  },
  mounted() {
    this.downloadUrl = location.origin + '/saas/api/system/combobox/getImportTemplate?fileName=' + 'lockInfo.xls'
    let curAuthlistPageTab = localStorage.getItem('curAuthlistPageTab')
    if (curAuthlistPageTab != null) {
      this.curActiveTab = curAuthlistPageTab
      this.$nextTick(() => {
        setTimeout(() => {
          this.getDataList()
        }, 300)
      })
    }
  },
  methods: {
    // 切换tab
    handleTabClick(tab) {
      this.curActiveTab = tab.paneName
      localStorage.setItem('curAuthlistPageTab', tab.paneName) // 记录当前设备授权名单页面选中的tab项，用途：刷新后恢复选中的tab

      this.getQuery()
    },
    // 获取字典数据
    getDictData(types) {
      if (!types || !types.length) return

      let url = 'RESOURCE.GET_MULTI_LIST'
      let params = types.map(item => `types=${item}`).join('&')

      this.fetchData({ url, method: "get", params, isGetParamsDirect: true }).then((res) => {
        if (!res) {
          return console.log(types, '==== 字典获取失败');
        }
        for (let key in res) {
          this.selOptions[key] = res[key]
          this.selOptionMaps[key] = {}
          res[key].forEach(item => {
            this.selOptionMaps[key][item.name] = item.value
          })
        }
      }).finally(res => {
        this.getDataList()
      });
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = {
        deviceCode: this.searchData.deviceCode || '',
        deviceType: this.curActiveTab,
        authFlag: this.searchData.authFlag,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      }
      if (this.fullArea && this.fullArea.length) {
        let areaCode = [...this.fullArea]
        params.shippingArea = areaCode.pop()
      }
      !params.deviceCode && (delete params.deviceCode)
      if (params.authFlag === '' || params.authFlag == null) {
        delete params.authFlag
      }

      let url = 'DEVICE.GET_AUTH_LIST'
      this.fetchData({ url, method: 'get', params })
        .then((res) => {
          if (res && res.data) {
            this.tableData = res.data
            this.pagination.total = Number(res.rowCount)
          } else {
            this.tableData = []
            this.pagination.total = 0
          }
        })
        .catch((err) => {
          this.$message.error(err)
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },
    // 初始化自定义表头
    initTableColumns() {
      let columns = [
        { prop: 'deviceCode', label: '设备编码', visible: true, minWidth: 160 },
        { prop: 'deviceModel', label: '设备型号', visible: true, minWidth: 160 },
        { prop: 'fullArea', label: '出货区域', visible: true, minWidth: 200 },
        { prop: 'authFlag', label: '授权状态', visible: true, minWidth: 120 },
        // { prop: 'projectName', label: '项目', visible: true, minWidth: 120 },
        { prop: 'createTime', label: '创建时间', visible: true, minWidth: 160 },
        { prop: 'updateTime', label: '更新时间', visible: true, minWidth: 160 },
      ]

      columns.forEach((item) => {
        if (item.prop == 'fullArea') {
          item.render = (row, index, column) => {
            let text = `${row.province || ''} ${row.city || ''} ${row.region || ''}`
            return <span>{text}</span>
          }
        } else if (item.prop == 'authFlag') {
          item.render = (row, index, column) => {
            switch(row.authFlag) {
              case 0:
                return <span style="color: #F56C6C">未授权</span>
              case 1:
                return <span style="color: #67C23A">已授权</span>
            }
            return <span>--</span>
          }
        } else {
          item.render = (row, index, column) => {
            if (row[item.prop] === '' || row[item.prop] == null) {
              return <span>--</span>
            }
            return <span>{row[item.prop]}</span>
          }
        }
      })

      this.tableColumn = columns
    },
    handleEdit(detailType) {
      this.$nextTick(() => {
        this.detailType = detailType
        this.detailModal = true
        if (detailType == 'edit' && this.options.selection.length) {
          this.detailData = { ...this.options.selection[0] }
        }
      })
    },
    // 处理删除
    handleDelete() {
      let ids = this.getProValues(this.options.selection)
      if (!ids.length) {
        this.$message({ type: 'info', message: '请选择数据！' })
        return
      }
      let tipStr = '确定删除当前选中的（' + ids.length + '条记录）信息吗？'
      this.$confirm(tipStr, { type: 'warning' }).then(() => {
        let params = { params: JSON.stringify({ ids: ids.join(',') }) }

        this.fetchData({
          url: this.deleteUrl,
          method: 'get',
          params,
          timeout: 0,
          isLoading: false,
          flag: true,
        }).then((res) => {
          let result = res.body || {}
          result = result.data || []
          if (res.status == 1) {
            if (result.length) {
              const h = this.$createElement;
              let msgList = result.map(msg => {
                return h('p', null, msg)
              })
              this.$msgbox({
                title: '温馨提示',
                message: h('div', null, msgList),
                showCancelButton: false,
                confirmButtonText: '确定'
              })
            } else {
              this.$message.success(res.msg || '操作成功！')
            }
            this.getDataList()
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        }).catch((err) => {
          console.log(err, 'delete err')
        })
      }).catch(() => false)
    },
    // 处理导入
    handleImport() {
      this.detailType = 'import'
      this.detailModal = true
    },
    submitSuccess() {
      this.detailModal = false
      this.detailType = ''
      this.getDataList()
    },
    // 显示导入时的重复数据
    showRepeatModal(result) {
      this.importResultData = result
      this.detailType = 'repeat'
      this.getDataList()
    },
    closeModel() {
      this.detailModal = false
    },
    // 处理重置搜索栏
    handleResetFilters() {
      this.fullArea = ''
      this.resetFilter()
    },
  },
}
</script>

<style lang="less" scoped>
.equip-auth-page {
  .page-operate-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: unset !important;
    :deep(.el-tabs__header) {
      margin-bottom: 0px;
    }
  }
}
</style>

<style lang="less">
.equip-auth-dialog .el-dialog__body {
  min-height: unset !important;
}
</style>